import { render, staticRenderFns } from "./AdminCommessa.vue?vue&type=template&id=4fcc7ce8&scoped=true"
import script from "./AdminCommessa.vue?vue&type=script&lang=js"
export * from "./AdminCommessa.vue?vue&type=script&lang=js"
import style0 from "./AdminCommessa.vue?vue&type=style&index=0&id=4fcc7ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcc7ce8",
  null
  
)

export default component.exports